import flatten from "lodash/flatten";

export const getCurrentForm = (questionnaire: RootStoreModule.State): RootStoreModule.Form => {
  const { currentForm } = questionnaire;

  // Array.prototype.findLast and default to first form
  const form = questionnaire.forms.reduce((acc, form) => {
    if (form.name === currentForm) acc = form;
    return acc;
  }, questionnaire.forms[0]);

  return form;
};

export const getActiveStep = (questionnaire: RootStoreModule.State): RootStoreModule.SectionForm => {
  const { activeStepName } = questionnaire;

  const currentForm = getCurrentForm(questionnaire);

  const forms = flatten(currentForm.sections.map((section) => section.forms));

  // Array.prototype.findLast and default to first form
  const activeStep = forms.reduce((acc, form) => {
    if (form.stepname === activeStepName) acc = form;
    return acc;
  }, forms[0]);

  return activeStep;
};

export const stepHasGuidedMode = (form: RootStoreModule.SectionForm) => {
  return form.guided && form.guided.length > 0;
};
